import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_API_TOKEN_ERROR: 'settings/integrations/FETCH_API_TOKEN_ERROR',
  FETCH_API_TOKEN_REQUEST: 'settings/integrations/FETCH_API_TOKEN_REQUEST',
  FETCH_API_TOKEN_SUCCESS: 'settings/integrations/FETCH_API_TOKEN_SUCCESS',
  GENERATE_NEW_API_TOKEN_ERROR:
    'settings/integrations/GENERATE_NEW_API_TOKEN_ERROR',
  GENERATE_NEW_API_TOKEN_SUCCESS:
    'settings/integrations/GENERATE_NEW_API_TOKEN_SUCCESS',
  GENERATE_NEW_API_TOKEN_REQUEST:
    'settings/integrations/GENERATE_NEW_API_TOKEN_REQUEST',
  REVOKE_API_TOKEN_ERROR: 'settings/integrations/REVOKE_API_TOKEN_ERROR',
  REVOKE_API_TOKEN_SUCCESS: 'settings/integrations/REVOKE_API_TOKEN_SUCCESS',
  REVOKE_API_TOKEN_REQUEST: 'settings/integrations/REVOKE_API_TOKEN_REQUEST',
};

export const fetchAPIToken = {
  error: notify(
    (error) => ({
      type: types.FETCH_API_TOKEN_ERROR,
      payload: error,
    }),
    'Unable to fetch an API Token',
  ),
  request: () => ({ type: types.FETCH_API_TOKEN_REQUEST }),
  success: ({ apiToken }) => ({
    type: types.FETCH_API_TOKEN_SUCCESS,
    payload: { apiToken },
  }),
};

export const generateNewAPIToken = {
  error: notify(
    (error) => ({
      type: types.GENERATE_NEW_API_TOKEN_ERROR,
      payload: error,
    }),
    'Unable to generate a new API Token',
  ),
  request: () => ({ type: types.GENERATE_NEW_API_TOKEN_REQUEST }),
  success: ({ apiToken }) => ({
    type: types.GENERATE_NEW_API_TOKEN_SUCCESS,
    payload: { apiToken },
  }),
};

export const revokeAPIToken = {
  error: notify(
    (error) => ({
      type: types.REVOKE_API_TOKEN_ERROR,
      payload: error,
    }),
    'Unable to revoke API Token',
  ),
  request: () => ({ type: types.REVOKE_API_TOKEN_REQUEST }),
  success: () => ({ type: types.REVOKE_API_TOKEN_SUCCESS }),
};
